import { Component, input } from '@angular/core';
import { TableSort } from '../../../shared/classes/TableSort';
import { Employee } from '../../../classes/models/employee/Employee';
import moment from 'moment';
import { TableHeader } from '../../../shared/classes/TableHeader';
import { SHARED_IMPORTS } from '../../../shared/standalone-imports';

/**
 * This component displays a list of all employees for a selected store.
 */
@Component({
    selector: 'app-employees-list',
    templateUrl: './employees-list.component.html',
    styleUrls: ['./employees-list.component.less'],
    imports: [SHARED_IMPORTS]
})
export class EmployeesListComponent {

  /** An identifier of a store. */
  storeId= input<string>();
  /** A list of all employees for a store. */
  employees= input<Employee[]>([]);

  /** A text by which employee list is filtered. */
  searchModel: string;
  /** A column and direction for a table to be sorted. */
  tableSortEvent: TableSort;
  /** Sortable headers of an employee table. */
  headers: TableHeader[] = [
    new TableHeader('Employee Name', 'name', true),
    new TableHeader('Role', 'role', true),
    new TableHeader('Contract Hours', 'contractHours', true),
    new TableHeader('Contract', 'contract', true)
  ];

  /**
   * Sorts the table by the given column in a given direction.
   * @param tableSortEvent a column and direction, in which table should be sorted.
   */
  onSort(tableSortEvent: TableSort): void {
    this.tableSortEvent = tableSortEvent;
  }

  /**
   * Finds, if an employee is currently active, or he will be soon available, or his contract will end soon.
   * @param employee an employee, which details are displayed.
   */
  getAvailability(employee: Employee): string {
    const availableFrom = this.getAvailableFrom(employee);
    const deletedFrom = this.getDeletedFrom(employee);
    if (availableFrom && deletedFrom) {
      return availableFrom + '. ' + deletedFrom;
    }
    if (availableFrom) {
      return availableFrom;
    }
    if (deletedFrom) {
      return deletedFrom;
    }
    return 'Active';
  }

  private getAvailableFrom(employee: Employee): string | null {
    if (employee.availableFrom && employee.availableFrom.isAfter(moment())) {
      return 'Starts on ' + employee.availableFrom.format('ddd, D MMM YYYY');
    }
    return null;
  }

  private getDeletedFrom(employee: Employee): string | null {
    if (employee.deletedFrom) {
      return 'Ends on ' + employee.deletedFrom.format('ddd, D MMM YYYY');
    }
    return null;
  }
}
